import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import Modal from "react-modal";
import "./Confirmacion.css"

// Establece el elemento de la aplicación para el modal
Modal.setAppElement('#root');

function Confirmacion({ tipo }) {
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar la visibilidad del modal

  const handleOpenModal = () => {
    setIsModalOpen(true); // Abrir el modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Cerrar el modal
  };

  // Formularios según tipo
  const formularioURL =
    tipo === "c"
      ? "https://forms.gle/uTYDJBnKc1SeCHoZ8"
      : "https://forms.gle/cjE1n2ADwsSf7DYz6";

  return (
    <div className="flex flex-col items-center bg-verde5">
      <div className='flex justify-center items-center mb-10 mt-10'>
        <Fade cascade={true} duration={3000}>
          <FontAwesomeIcon icon={faCalendarCheck} size="5x" className="text-verde2" />
        </Fade>
      </div>
      <div className="text-1xl font-bold text-verde2 mb-4 ml-7 mr-7 text-center">
        <p>Para nosotros es muy importante compartir esta alegría con ustedes.</p>
        <p>¡Nos encantaría contar con tu asistencia!</p>
        <p>¡Confírmanos tu asistencia antes del 24 de Octubre!</p>
      </div>
      <Fade direction="left">
        <button
          className="font-bold text-lg text-verde5 mb-10 bg-verde2 rounded-md px-6 py-2 transition-colors duration-300 ease-in-out hover:bg- focus:outline-none focus:ring-2 focus:ring- focus:ring-opacity-50"
          onClick={handleOpenModal} // Cambiar a abrir el modal
        >
          Confirmar
        </button>
      </Fade>

      {/* Modal para el formulario de Google */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Confirmar Asistencia"
        className="modal"
        overlayClassName="overlay"
      >
        <h2 className="text-center text-xl font-bold mb-4">Confirmar Asistencia</h2>
        <iframe
         src={formularioURL}
          width="100%"
          height="500px"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Formulario de Confirmación de Asistencia"
        >
          Cargando…
        </iframe>
        <button
          onClick={handleCloseModal}
          className="mt-4 bg-verde2 text-white rounded-md px-4 py-2"
        >
          Cerrar
        </button>
      </Modal>
    </div>
  );
}

export default Confirmacion;
